const e = (e, t = 500) => {
    let c = 0;
    const o = () => clearTimeout(c), a = (...a) => {
        o(), c = setTimeout(e, t, ...a);
    };
    return a.cancel = o, a;
};

export { e as default };
//# sourceMappingURL=index.js.map
